/** Maximum CSV file size for bulk label value upload (1 MiB). */
export const MAX_CSV_FILE_SIZE_BYTES = 1024 * 1024;

export const CSV_FILE_EXTENSION = '.csv';

export const CSV_UPLOAD_MIME_TYPES = new Set([
	'text/csv',
	'application/csv',
	'text/comma-separated-values'
]);
